import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import { Section } from "@/components/common/Section";
import { Container } from "@/components/common/Container";
import { SectionHeading } from "@/components/common/SectionHeading";

import { services } from "@/data/home.data";

import {
  staggerContainer,
  fadeUp,
  viewportOnce,
} from "@/animations/motion";

import { ArrowRight } from "@/icons";

export function ServicesGrid() {
  return (
    <Section id="services">
      <Container>
        <SectionHeading
          eyebrow="Our Services"
          title="Technology Solutions Powered by AI Automation Tailored Around Your Business Goals"
          description="From AI-powered automation and enterprise platforms to mobile and cloud applications, we deliver technology solutions that simplify operations, improve productivity and support long-term business growth."
        />

        <motion.div
          variants={staggerContainer(0.08, 0.12)}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="mt-14 grid gap-6 sm:grid-cols-2 xl:grid-cols-3"
        >
          {services.map(
            ({
              id,
              title,
              summary,
              icon: Icon,
              best_for,
              category,
            }) => (
              <motion.article
                key={id}
                variants={fadeUp}
                className="group relative flex h-full flex-col overflow-hidden rounded-3xl border border-border bg-card transition-all duration-300 hover:-translate-y-2 hover:border-primary/20 hover:shadow-2xl"
              >
                {/* Decorative glow */}
                <div className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                  <div className="absolute right-0 top-0 h-40 w-40 rounded-full bg-primary/10 blur-3xl" />
                </div>

                <div className="relative p-8">

                  {/* Category */}
                  {category && (
                    <span className="inline-flex rounded-full bg-primary/10 px-3 py-1 text-xs font-medium text-primary">
                      {category}
                    </span>
                  )}

                  {/* Icon */}
                  <div className="mt-5 inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary transition-all duration-300 group-hover:bg-primary group-hover:text-primary-foreground">
                    <Icon className="h-6 w-6" />
                  </div>

                  {/* Title */}
                  <h3 className="mt-6 font-heading text-2xl font-semibold">
                    {title}
                  </h3>

                  {/* Description */}
                  <p className="mt-3 text-sm leading-7 text-muted-foreground">
                    {summary}
                  </p>

                  {/* Best For */}
                  {best_for && (
                    <div className="mt-5 rounded-xl border border-border bg-muted/40 p-4">
                      <div className="text-xs font-semibold uppercase tracking-wide text-primary">
                        Best For
                      </div>

                      <div className="mt-2 text-sm text-muted-foreground">
                        {best_for}
                      </div>
                    </div>
                  )}

                  {/* CTA */}
                  <Link
                    to={`/services/${id}`}
                    className="mt-8 inline-flex items-center gap-2 font-medium text-primary transition-all duration-300 group-hover:gap-3"
                  >
                    View Service
                    <ArrowRight className="h-4 w-4" />
                  </Link>
                </div>
              </motion.article>
            )
          )}
        </motion.div>
      </Container>
    </Section>
  );
}